import React from "react";
import { Badge, Button } from "react-bootstrap";
import { canUploadAnnualMaskCertificate, getAnnualMaskPhysicianCertificateState, isAnnualMaskCertificateUploadLocked } from "./annualMaskPhysicianUpload";

const AnnualMaskPhysicianCase = ({ caseItem, currentUser, saving, onUpload, renderFileButton }) => {
  const patient = caseItem.patient || caseItem;
  const name = [patient.firstnameTh || patient.firstname, patient.lastnameTh || patient.lastname].filter(Boolean).join(" ");
  const state = getAnnualMaskPhysicianCertificateState(caseItem);
  const locked = isAnnualMaskCertificateUploadLocked(caseItem);
  const signed = caseItem.signedMedicalCertificate;
  return (
    <section className="border-top p-3" aria-label={`Certificate for ${name || caseItem.hn}`}>
      <div className="d-flex justify-content-between align-items-start flex-wrap">
        <div className="mr-3 mb-2">
          <h6 className="mb-1">{name || caseItem.hn}</h6>
          <div className="small text-muted">HN: {caseItem.hn}{caseItem.sourceFollowupDate ? ` · Follow-up: ${caseItem.sourceFollowupDate}` : ""}</div>
          <Badge variant={state === "Uploaded" ? "success" : state === "Locked" ? "secondary" : "warning"} className="mt-2">{state}</Badge>
        </div>
        <Button variant="primary" className="mb-2" disabled={saving || locked || !canUploadAnnualMaskCertificate(caseItem, currentUser)} onClick={() => onUpload(caseItem)}>
          <i className="fa fa-upload mr-2" aria-hidden="true" />
          {signed ? "Replace signed medical certificate" : "Upload signed medical certificate"}
        </Button>
      </div>
      <div className="small font-weight-bold mt-2 mb-1">Review documents</div>
      <div className="d-flex flex-wrap">
        {caseItem.generatedMedicalCertificate && renderFileButton("Medical certificate to sign", caseItem.generatedMedicalCertificate)}
        {caseItem.usageReport && renderFileButton("CPAP Usage Report", caseItem.usageReport)}
        {caseItem.sleepStudyReport && renderFileButton("Sleep Study Report", caseItem.sleepStudyReport)}
        {signed && renderFileButton("Review signed certificate", signed, "outline-success")}
      </div>
      {signed && <div className="small text-success mt-1" style={{ overflowWrap: "anywhere" }}><i className="fa fa-check-circle mr-1" aria-hidden="true" />{signed.fileName || "Signed certificate uploaded"}</div>}
      <div className="small text-muted mt-2">
        {locked ? "Certificate changes are locked. Contact an administrator if a replacement is needed." : signed ? "Signed certificate uploaded. An administrator will handle the remaining steps." : "Review the documents, then upload the signed medical certificate as a PDF. An administrator will handle the remaining steps."}
      </div>
    </section>
  );
};
export default AnnualMaskPhysicianCase;
